import type { ChildTicketTask } from '@/lib/services/childTicketService'
import { getModule, resolveModuleForField } from './registry'
import { dependenciesMet, resolveTaskFormFields } from './resolveFormFields'
import type { TaskFieldContext, TaskFormFieldDefinition, ValidationResult } from './types'

function buildContext(
  field: TaskFormFieldDefinition,
  fields: TaskFormFieldDefinition[],
  task: ChildTicketTask,
  parentTicketId: string,
  formData: Record<string, unknown>,
  ticketPropertiesProps?: Record<string, unknown>,
): TaskFieldContext {
  const storeId = ticketPropertiesProps?.storeId as number | null | undefined
  return {
    field,
    task,
    parentTicketId,
    formData,
    onFormDataChange: () => {},
    ticketPropertiesProps,
    allFields: fields,
    valuesByKey: formData,
    storeId,
  }
}

export function validateTaskFormFields(
  task: ChildTicketTask,
  parentTicketId: string,
  formData: Record<string, unknown>,
  ticketPropertiesProps?: Record<string, unknown>,
): ValidationResult {
  const fields = resolveTaskFormFields(task)
  const storeId = ticketPropertiesProps?.storeId as number | null | undefined

  for (const field of fields) {
    const mod = resolveModuleForField(field) ?? getModule(field.module)
    const ctx = buildContext(field, fields, task, parentTicketId, formData, ticketPropertiesProps)

    const dep = dependenciesMet(field, formData, storeId, fields)
    if (!dep.ok) {
      return { valid: false, message: dep.message ?? `Complete dependencies for "${field.label}" first.` }
    }

    const blocked = mod?.isBlocked?.(ctx)
    if (blocked?.blocked) {
      return { valid: false, message: blocked.message ?? `"${field.label}" is not ready.` }
    }

    if (mod?.validate) {
      const result = mod.validate(ctx)
      if (!result.valid) return result
    } else if (field.required) {
      const v = formData[field.key]
      if (v === null || v === undefined || String(v).trim() === '') {
        return { valid: false, message: `"${field.label}" is required` }
      }
    }
  }

  return { valid: true }
}
